import { useState } from "react";
import { IconButton2 } from "src/components/IconButton2/IconButton2.tsx";
import { copyToClipboard } from "@exonn/utils";
import { Copy } from "src/lib/ui-icon-v2";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";

await loadTranslations(TranslationNamespaceEnum.CopyButtonComponent);

export const CopyButton = ({ text }: { text: string }) => {
  const [copied, setCopied] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const { t } = useTranslation(TranslationNamespaceEnum.CopyButtonComponent);
  return (
    <IconButton2
      tooltipProps={{
        open: tooltipOpen,
        onOpenChange: setTooltipOpen,
      }}
      helperText={copied ? t("copied") : t("copy")}
      onClick={async () => {
        await copyToClipboard(text);
        setCopied(true);
        setTooltipOpen(true);

        setTimeout(() => {
          setCopied(false);
          setTooltipOpen(false);
        }, 1000);
      }}
      skin={"info"}
    >
      {copied ? <span className={"icon-15-chk_mrk"} /> : <Copy />}
    </IconButton2>
  );
};
